export const filterData = (users, searchQuery) => {
    return users?.filter(user => user?.firstName?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
        user?.lastName?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
        user?.email?.toLowerCase().includes(searchQuery?.toLowerCase()));
}